export var FilterTypeDTO;
(function (FilterTypeDTO) {
    FilterTypeDTO["CATEGORY"] = "CATEGORY";
    FilterTypeDTO["FILTERED_CATEGORIES"] = "FILTERED_CATEGORIES";
    FilterTypeDTO["OPTIONS"] = "OPTIONS";
    FilterTypeDTO["PRICE"] = "PRICE";
})(FilterTypeDTO || (FilterTypeDTO = {}));
export var FilterEqOperation;
(function (FilterEqOperation) {
    FilterEqOperation["EQUALS"] = "EQUALS";
    FilterEqOperation["GTE"] = "GTE";
    FilterEqOperation["LTE"] = "LTE";
    FilterEqOperation["BETWEEN"] = "BETWEEN";
    FilterEqOperation["IN"] = "IN";
    FilterEqOperation["IN_ALL"] = "IN_ALL";
})(FilterEqOperation || (FilterEqOperation = {}));
//# sourceMappingURL=serverRequests.js.map